import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionPhonePermissions extends BaseScenesPermissions {}

export default EmissionPhonePermissions
